import React from 'react';

export const Background = () => {
  return (
    <div className="__front_background__" />
  );
}
